import { render, staticRenderFns } from "./addWechat.vue?vue&type=template&id=4c8c2899&scoped=true&"
import script from "./addWechat.vue?vue&type=script&lang=js&"
export * from "./addWechat.vue?vue&type=script&lang=js&"
import style0 from "./addWechat.vue?vue&type=style&index=0&id=4c8c2899&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c2899",
  null
  
)

export default component.exports